import { invalid, regex, required } from "common/forms"
import * as yup from "yup"

const schema = yup
  .object({
    licenceNumber: yup
      .string()
      .required(required.licenseNumber)
      .matches(regex.licenseNumber, invalid.licenseNumber),
  })
  .defined()

export const initialFormState: yup.InferType<typeof schema> = {
  licenceNumber: "",
}

export default schema
